import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Output, Inject } from '@angular/core';


@Component({
  selector: 'app-token',
  templateUrl: './token.component.html',
  styleUrls: ['./token.component.scss']
})
export class TokenComponent {
  inputLength = 6;
  inputValues: any[] = [];
  @Output() getValues = new EventEmitter();
  
  constructor(@Inject(DOCUMENT) private document: Document) {}

  get arrData() {
    return new Array(this.inputLength)
  }

  getInput(value: any, index: number) {
    this.inputValues[index] = value;   
    const values = this.inputValues.map(val => val).join('');
    this.getValues.emit(values)     
  }
  async inputDrop(event: any) {
    try {
      const copiedText: any = await navigator.clipboard.readText();
      const inputElements = this.document.querySelectorAll('.token-input input');
      inputElements.forEach((inputEl, i) => {
        const value = copiedText[i];
        if(!value) return;
        (inputEl as any).value = value;
        (inputEl as any).select();
        this.getInput(value, i);
      })      
    } catch (error) {
      
    }    
  }
}
